module.exports = new Promise(async (resolve, reject) => {
  try {
    const module = await import('https://sn2-whiteboard-dev11.web.app/assets/remoteEntry.js?t=1773890302983');
    resolve(module);
  } catch (error) {
    // console.error('Failed to load remote:', error);
    resolve(null);
  }
})
;